import React, { useEffect, useMemo, useState } from 'react';
import { fetchActiveStudents } from '../../../services/teacherViewData';

// Teacher dashboard — read-only active-student roster (gated viewStudents).
// Teachers never write students; this is a reference list only.
function TeacherStudents() {
	const [students, setStudents] = useState([]);
	const [status, setStatus] = useState('loading'); // loading | ready | error
	const [q, setQ] = useState('');

	useEffect(() => {
		let alive = true;
		fetchActiveStudents()
			.then((rows) => {
				if (!alive) return;
				setStudents(rows);
				setStatus('ready');
			})
			.catch((err) => {
				console.error('Failed to load students:', err);
				if (alive) setStatus('error');
			});
		return () => {
			alive = false;
		};
	}, []);

	const filtered = useMemo(() => {
		const needle = q.trim().toLowerCase();
		if (!needle) return students;
		return students.filter((s) =>
			`${s.fullName || ''} ${s.instrument || ''} ${s.school || ''}`
				.toLowerCase()
				.includes(needle)
		);
	}, [students, q]);

	if (status === 'loading') {
		return <div className='td-state'>Loading students…</div>;
	}
	if (status === 'error') {
		return (
			<div className='td-state'>
				Couldn’t load the roster. Try again in a moment.
			</div>
		);
	}
	if (students.length === 0) {
		return <div className='td-state'>No active students yet.</div>;
	}

	return (
		<div className='td-students'>
			<div className='td-students__bar'>
				<span className='td-students__count'>
					{filtered.length} active student
					{filtered.length === 1 ? '' : 's'}
				</span>
				<input
					className='td-students__search'
					type='search'
					placeholder='Search name, instrument…'
					value={q}
					onChange={(e) => setQ(e.target.value)}
					aria-label='Search students'
				/>
			</div>
			<ul className='td-students__list'>
				{filtered.map((s) => (
					<li key={s.id} className='td-student'>
						<div className='td-student__name'>
							{s.fullName ||
								`${s.firstName || ''} ${s.lastName || ''}`.trim() ||
								'Unnamed student'}
						</div>
						<div className='td-student__meta'>
							{s.instrument && (
								<span className='td-chip'>
									<i className='fa-sharp fa-solid fa-music' />
									{s.instrument}
								</span>
							)}
							{s.school && (
								<span className='td-student__school'>
									{s.school}
								</span>
							)}
						</div>
					</li>
				))}
			</ul>
		</div>
	);
}

export default TeacherStudents;
